import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '../cx.js';

export type VarianteBadge = 'neutral' | 'success' | 'warning' | 'error' | 'accent';

export interface BadgeProps {
  variant?: VarianteBadge;
  /** Icona obbligatoria di fatto: lo stato non si affida mai al solo colore. */
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}

const stili: Record<VarianteBadge, string> = {
  neutral: 'bg-surface-sunken text-ink',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  error: 'bg-error-soft text-error',
  accent: 'bg-accent-soft text-accent',
};

/** Etichetta di stato: pillola con icona e parola. */
export function Badge({ variant = 'neutral', icon: Icon, children, className }: BadgeProps) {
  return (
    <span className={cx('inline-flex items-center gap-1 rounded-sm px-2 py-1 t-caption whitespace-nowrap', stili[variant], className)}>
      {Icon && <Icon aria-hidden size={14} strokeWidth={1.75} />}
      {children}
    </span>
  );
}
